import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import Script from 'next/script';

import OneTrustButton from 'src/components-v3/Footer/OneTrustButton';
import { Banner, UnidentifiedTraffic } from 'src/components/Feedback';
import { ContactRoutingJumpLinks } from 'src/components-v3/ContactRouting/ContactRoutingJumpLinks';
import { Link } from 'src/components/Inputs';
import { MetaTags } from 'src/components/MetaTags';
import { ConsentManager } from 'src/containers/ConsentManager';
import { noJSBannerData } from 'src/store/banners';

import { AnalyticsProvider, LocaleContext } from 'src/contexts';
import { Locales } from 'src/lib/constants';
import SiteNavigation from 'src/components-v3/SiteNavigation/SiteNavigation';

// dynamically import the scripts component which invokes all of our js dependencies
const DemoTemplateScripts = dynamic(
  () => {
    return import('src/templates/DemoTemplate/DemoTemplateScripts');
  },
  {
    ssr: false,
  },
);

const Demo = ({ children, locale = Locales.EN_US, ...props }) => {
  const { route } = useRouter();

  return (
    <LocaleContext.Provider value={locale}>
      <AnalyticsProvider>
        <MetaTags {...props} />

        {/* eslint-disable-next-line @next/next/no-before-interactive-script-outside-document -- This must load first, but we don't want to include it globally. Dependent scripts should eventually be refactored to hook into `onLoad`. */}
        <Script
          src='https://cdn.plaid.com/link/v2/stable/link-initialize.js'
          strategy='beforeInteractive'
        />

        <noscript>
          <Banner {...noJSBannerData} />
        </noscript>

        <SiteNavigation locale={locale} skipLinkAnchor='#demo-content' />

        <div id='demo-content' className={`accounts demo`}>
          {children}

          <div id='footer' className='footer footer--is-slim'>
            <div className='grid-container'>
              <div className='grid-x grid-margin-x footer-details footer-details--is-slim'>
                <div className='cell cell--is-line-break medium-12'></div>
                <div className='cell small-12 medium-4 menu'>
                  <p>
                    Want to learn more about Plaid?{' '}
                    <Link href='/'>
                      <a>Visit us here.</a>
                    </Link>
                  </p>
                </div>
                <div className='cell small-12 medium-4 cell--justify-center-medium'>
                  <OneTrustButton
                    sx={{ fontSize: '1.4rem', fontWeight: 400, mb: '1.6rem' }}
                  />
                </div>
                <div className='cell cell--align-right small-12 medium-4'>
                  <p className='footer-copyright'>
                    &copy; {new Date().getFullYear()} Plaid Inc.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConsentManager />
        <UnidentifiedTraffic />
        <ContactRoutingJumpLinks />
        <DemoTemplateScripts route={route} />
      </AnalyticsProvider>
    </LocaleContext.Provider>
  );
};

export default Demo;
